import PricingMethods from '~/api/methods/pricing';
import BookingRequest from '~/api/requests/booking/one';
import PricingResult from '~/api/entities/pricing/result';
import Requirements from '~/api/entities/requirements';

export default {
  data () {
    const { params, query } = this.$route;
    return {
      request: new BookingRequest(query.search || params.id),
      pricingSender: new PricingMethods(),
      requirements: null,
      error: null,
      result: null,
      searchPending: false,
    };
  },
  computed: {
    formRef () {
      if (!this.$refs?.form) return null;
      return this.$refs.form.$refs.form || this.$refs.form;
    },
  },
  async mounted () {
    if (this.isCabinet) {
      const { params, query } = this.$route;
      if (!query.search && !params.id && !this.request.departure) {
        const geolocation = await this.$store.dispatch('getGeolocation');
        if (geolocation) this.request.departure = geolocation.codeEn;
      }
    }
  },
  methods: {
    search (withReset = true) {
      const errors = this.validate();
      if (errors) return Promise.resolve();
      this.searchPending = true;
      if (this.result) this.result.clear();
      if (withReset) this.resetRaids();
      return this.pricingSender.getNewPricing(this.request)
        .then(res => {
          this.clearServerValidationErrors();

          this.handleVariants(res.data);
          this.afterSearch();

          return Promise.resolve(res);
        })
        .catch(err => {
          this.handleErrors(err);
        })
        .finally(() => {
          this.searchPending = false;
        });
    },
    getAirportRequirements () {
      this.searchPending = true;
      return this.pricingSender.getRequirements(this.request)
        .then(res => {
          this.requirements = new Requirements(res.data);
        })
        .catch(err => {
          this.handleErrors(err);
        })
        .finally(() => {
          this.searchPending = false;
        });
    },
    clearServerValidationErrors () {
      if (!this.isCabinet) {
        this.formRef?.$refs?.mawbForm?.clearServerValidationErrors();
      }
      this.formRef?.$refs?.cargoForm?.clearServerValidationErrors();
      this.formRef?.$refs?.directionForm?.clearServerValidationErrors();
    },
    handleErrorValidation (err) {
      if (!this.isCabinet) {
        this.formRef.$refs.mawbForm.addServerValidationErrors(err);
      }
      this.formRef.$refs.cargoForm.addServerValidationErrors(err);
      this.formRef.$refs.directionForm.addServerValidationErrors(err);
    },
    validate (type = 'pricing') {
      this.request.validationType = type;
      const mawbErrors = this.isCabinet
        ? null
        : this.formRef.$refs.mawbForm.validate();
      const directionErrors = this.formRef.$refs.directionForm.validate();
      const cargoErrors = this.formRef.$refs.cargoForm.validate();

      return directionErrors || cargoErrors || mawbErrors;
    },
    handleVariants (variants) {
      this.result = new PricingResult(variants);
    },
    resetRaids () {
      this.request.raids.length = 0;
    },
    afterSearch () {

    },
  },
};
